import React, { useState } from "react";
import { AppLayout } from "../../../layout/AppLayout";
import { Arrow } from "../../../components/svg/Wallet/Wallet";
import { Card } from "../../../components/Card";
import { useNavigate } from "react-router-dom";
import {
  BankOutlined,
  Cheveron,
} from "../../../components/svg/worldSvgs/rmc/Achievements";
import { BiChevronDown } from "react-icons/bi";
import Select from "../../../components/Select";
import { BaseInput } from "../../../components/input/baseInput";
import clsx from "clsx";
import Button from "../../../components/button/Button";
import {
  accountDetails,
  transaction,
  transactionSummary,
} from "./savedAccount";
import { FullModal } from "../../world/rmc/modals/fullModal";
import { SuccessModal } from "../../../components/modals/SuccessModal";
import { Keypad } from "../../../components/keypad";
import { CustomPinInput } from "../../../components/input/CustomPinInput";
import { AnimatePresence } from "framer-motion";

const banks = [
  { label: "Bank of America", value: "boa" },
  { label: "Chase", value: "chase" },
  { label: "Wells Fargo", value: "wells-fargo" },
  { label: "Citibank", value: "citi" },
  { label: "US Bank", value: "us-bank" },
  { label: "TD Bank", value: "td-bank" },
];

export const WithdrawIndex = () => {
  const [show, setShow] = useState(false);
  const [success, setSuccess] = useState(false);
  const [confirmDetails, setConfirmDetails] = useState(false);
  const [pin, setPin] = useState("");
  const pinLength = 4;
  const [bank, setBank] = useState({});
  const navigate = useNavigate();
  return (
    <AppLayout noNav bg={"!bg-[#F8F8F8]"}>
      <div className=" min-h-screen px-4 pt-10 pb-8">
        <div className="relative flex items-center justify-center">
          <Arrow
            onClick={() => navigate(-1)}
            stroke="#fff"
            className="text-lg absolute left-0 cursor-pointer  "
          />
          <p className="font-bold text-xl text-primary-black">Withdraw</p>
        </div>
        <div className="mt-10 flex flex-col gap-5">
          <Card>
            <p className="text-sm text-primary-black font-medium mb-3.5">
              Saved Account
            </p>
            <div
              onClick={() => navigate("/settings/wallet/withdraw/saved")}
              className="flex justify-between items-center gap-3 cursor-pointer"
            >
              <div className="flex">
                <div className="mr-3">
                  <BankOutlined bgFill="#ECECEC80" fill="#B4B4B4" />{" "}
                </div>
                <div>
                  <p className="text-sm font-medium text-primary-black mb-2">
                    John Doe
                  </p>
                  <p className="text-[#00000080] text-xs">
                    0000222000 Guarantee Trust Bank
                  </p>
                </div>
              </div>

              <BiChevronDown className="-rotate-90 text-[#00000080]" />
            </div>
          </Card>
          <Card>
            <BaseInput
              label="Account number"
              type="number"
              placeholder="Enter 10 digits Account number"
              inputClass="bg-[#F8F8F8]"
              className="mb-5"
            />

            <Select
              leadingIcon={
                <div className="mr-3">
                  <BankOutlined bgFill="#ECECEC80" fill="#B4B4B4" />{" "}
                </div>
              }
              trailingIcon={
                <Cheveron stroke="#00000080" className="rotate-90" />
              }
              options={banks}
              selected={bank}
              setSelected={setBank}
              label="Bank name"
              placeholder="Select Bank"
              cheveronClass="!text-[#00000080]"
              selectedOptionClass="bg-[#2741D6] !text-white"
              className="mb-5"
              labelClass="text-primary-black"
              selectedClass={clsx(
                "base_select_selected !bg-[#F8F8F8] !rounded-[50px]",
                bank?.value ? "text-primary-black" : "!text-[#00000080]"
              )}
              dropdownClass="base_select_dropdown !bg-white !shadow-lg "
              optionsClass="base_select_options !text-primary-black hover:!bg-[#2741D6] hover:!text-white"
            />

            <div className="mb-5">
              <BaseInput
                label="Enter Amount"
                type="number"
                placeholder="500 - 99,999"
                inputClass="bg-[#F8F8F8]"
              />
              <span className="text-[10px] text-[#00000080] font-medium">
                Available Balance: ₦30,000
              </span>
            </div>
            <BaseInput
              label="Description"
              placeholder="What’s this for?(optional)"
              inputClass="bg-[#F8F8F8]"
            />
          </Card>

          <Button
            onClick={() => setShow(true)}
            text="Withdraw Funds"
            className="!py-4 !mt-7 !rounded-[50px] "
          />
        </div>
      </div>
      <AnimatePresence>
        {show && (
          <FullModal
            className={clsx(
              "h-[450px] fixed inset-x-0 bottom-0 z-[4000] bg-[#F8F8F8] animate-slide-up 480:max-w-[440px] 480:mx-auto rounded-t-[20px] overflow-hidden"
            )}
            onClose={() => setShow(false)}
          >
            <div className="py-5 px-10 bg-white flex flex-col">
              <div
                onClick={() => setShow(false)}
                className="bg-[#4B5563] w-[50px] rounded-[5px] h-[6px] grid place-self-center mb-6 cursor-pointer"
              ></div>

              <h2 className="text-base font-medium text-center text-primary-black mb-4">
                Enter Transaction Pin
              </h2>

              <CustomPinInput disabled pin={pin} />
            </div>
            <Keypad
              pinLength={pinLength}
              pin={pin}
              setPin={setPin}
              onPinComplete={() => {
                setConfirmDetails(true);
                setPin("");

                setTimeout(() => {
                  setShow(false);
                }, 200);
              }}
            />
          </FullModal>
        )}
      </AnimatePresence>
      <AnimatePresence>
        {confirmDetails && (
          <FullModal
            className={clsx(
              "h-[576px] fixed inset-x-0 bottom-0 z-[4000] bg-[#F8F8F8] animate-slide-up 480:max-w-[440px] 480:mx-auto rounded-t-[20px] overflow-hidden"
            )}
            onClose={() => setConfirmDetails(false)}
          >
            <div className="pt-5 pb-1 px-5 bg-white flex flex-col">
              {" "}
              <div
                onClick={() => setConfirmDetails(false)}
                className="bg-[#4B5563] w-[50px] rounded-[5px] h-[6px] grid place-self-center mb-6 cursor-pointer"
              ></div>
              <div className="bg-[#F8F8F8] p-4">
                <div className="flex flex-col gap-5 mb-6 text-primary-black">
                  {accountDetails.map((item, index) => (
                    <div key={index}>
                      <p className="text-primary-black text-sm font-normal">
                        {item.label}
                      </p>
                      <p className="text-primary-black text-base font-semibold">
                        {item.value}
                      </p>
                    </div>
                  ))}
                </div>

                <div className="flex gap-3 flex-col items-center">
                  {transactionSummary.map((item, index) => (
                    <div
                      key={index}
                      className="w-full flex justify-between items-center gap-4"
                    >
                      <p className="text-primary-black text-sm font-normal">
                        {item.label}
                      </p>
                      <span className="text-primary-black text-base font-semibold">
                        {item.value}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="mt-10">
                <Button
                  onClick={() => {
                    setSuccess(true);
                    setConfirmDetails(false);
                  }}
                  text="Confirm & Continue"
                  className="!py-4 !rounded-[50px] "
                />
                <Button
                  onClick={() => setConfirmDetails(false)}
                  text="Cancel"
                  className="!py-4 mt-5 !rounded-[50px] button_cancel !text-[#B4B4B4] !shadow-none"
                />
              </div>
            </div>
          </FullModal>
        )}
      </AnimatePresence>
      <AnimatePresence>
        {success && (
          <SuccessModal
            action="Withdrawal"
            transaction={transaction}
            onClick={() => {
              setSuccess(false);
              setTimeout(() => {
                navigate("/settings/wallet");
              }, 200);
            }}
          />
        )}
      </AnimatePresence>
    </AppLayout>
  );
};
